var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: [_vm.labelVariants({
      variant: _vm.variant,
      size: _vm.size
    })]
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }